import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {useMediaQuery, Theme} from '@material-ui/core';
import { MenuItemLink} from 'react-admin';
import SubMenu from './SubMenu';
// import DefaultIcon from '@material-ui/icons/ViewList';
import {getResources} from 'ra-core';
import {IMenuGroup} from '../../consts/interfaces/Interfaces';
import LabelIcon from '@material-ui/icons/Label';

interface Props {
   dense: boolean;
   logout: () => void;
   onMenuClick: () => void;
}

function groupBy(list: Array<any>, key: string) {
   const result: Array<any> = [];
   const usedID: Array<number> = [];
   list?.forEach((item) => {
      const group = item?.options[key] as IMenuGroup;
      if (usedID.indexOf(group?.id) === -1) {
         if (group !== undefined) {
            let groupArr = list.filter((el) => (el.options[key] as IMenuGroup)?.id === group.id);
            if (groupArr.length > 0) {
               usedID.push(group.id);
               result.push(groupArr);
            }
         } else result.push(item);
      }
   });
   return result;
}

const Menu: FC<Props> = ({onMenuClick, dense, logout}) => {
   const isXSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));
   const open = useSelector((state: any) => state.admin.ui.sidebarOpen);
   const resources = useSelector(getResources).filter((el) => el.hasList || el.hasCreate);

   const groupedResources = groupBy(resources, 'group');

   return (
      <div>
         {' '}
         {groupedResources.map((resource, index) => {
            if (resource instanceof Array) {
               const group: IMenuGroup = resource[0]?.options?.group;
               return (
                  <SubMenu key={index} sidebarIsOpen={open} name={group?.name} icon={group?.icon} dense={dense}>
                     {resource.map((resource: any, index) => (
                        <MenuItemLink
                           key={resource.name + index}
                           to={'/' + resource.name}
                           primaryText={(resource.options && resource.options.label) || resource.name}
                           leftIcon={resource.icon ? <resource.icon /> : <LabelIcon />}
                           onClick={onMenuClick}
                           sidebarIsOpen={open}
                           dense={dense}
                        />
                     ))}
                  </SubMenu>
               );
            }
            return (
               <MenuItemLink
                  key={index}
                  to={'/' + resource.name}
                  primaryText={(resource.options && resource.options.label) || resource.name}
                  leftIcon={resource.icon ? <resource.icon /> : <LabelIcon />}
                  onClick={onMenuClick}
                  sidebarIsOpen={open}
                  dense={dense}
               />
            );
         })}
         {isXSmall && logout}
      </div>
   );
};

export default Menu;
